import Loading from "../Loading";
import WorkerListItem from "./WorkerListItem";
import clsx from "clsx";
import styles from "./WorkerInfoModal.module.scss";
import { useTranslation } from "next-i18next";

const CheckinList = ({ loading, line, workersData, toggleModal }) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx("bg-light mt-2 px-4 py-4", styles.checkinList)}
    >
      <div className="d-flex flex-row justify-content-between">
        <h2 className="fw-bold" style={{ fontSize: 18 }}>
          {t("views.checkin.list.title")}
        </h2>
        <p style={{ fontSize: 12 }}>
          {t("views.checkin.list.subtitle")} {workersData?.length || 0}
        </p>
      </div>
      {loading ? (
        <Loading height="h-25" />
      ) : (
        <>
          {" "}
          {workersData?.length === 0 && (
            <div
              className="d-flex justify-content-center px-3"
              style={{ minHeight: 91, alignItems: 'center' }}
            >
              {" "}
              <p
                style={{ maxWidth: 180, margin: 0 }}
                className="text-muted text-center"
              >
                {t("views.checkin.list.empty")}
              </p>
            </div>
          )}
          {workersData?.map((workerData, index) => {
            return (
              <WorkerListItem
                key={index}
                handleClick={() => toggleModal(workerData?.worker)}
                line={line}
                workerData={workerData}
              />
            );
          })}{" "}
        </>
      )}
    </div>
  );
};

export default CheckinList;
